export default __webpack_public_path__ + "static/media/visa.1b0dc479.svg";